export type FinalResults = {
	votingType: "ranked" | "quadratic";
	voteCount: number;
	optionTallies: { id: number; content: string; score: number; normalized: number }[];
	winners: number[];
	tieBands: { y: number }[];
};

export function isFinalResults(x: unknown): x is FinalResults {
	if (!x || typeof x !== "object") return false;
	const o = x as Record<string, unknown>;
	if (o.votingType !== "ranked" && o.votingType !== "quadratic") return false;
	if (typeof o.voteCount !== "number") return false;
	if (!Array.isArray(o.optionTallies) || !Array.isArray(o.winners) || !Array.isArray(o.tieBands)) return false;
	return true;
}
